/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
// import { Component } from '@wordpress/element';
//
// import times from 'lodash/times';

// import {
// 	InnerBlocks,
// } from '@wordpress/block-editor';

import { useEffect } from '@wordpress/element';
import {
	InnerBlocks,
} from '@wordpress/block-editor';
import { withDispatch, select } from '@wordpress/data';
import { compose } from '@wordpress/compose';
import memoize from 'memize';
import times from 'lodash/times';

/**
 * Inner dependencies.
 */
// import Inspector from './inspector';
// import { appendStyleTag } from '../../extensions/custom-styles';
// import BaseWrapper from '../../components/base-wrapper';
// import TeamStyle from './inline-styles';

import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
import { updateBlockStyle } from './inline-styles';

/**
 * Constants
 */
const ALLOWED_BLOCKS = [ 'gutenify/team-member' ];

/**
 * Returns the layouts configuration for a given number of feature items.
 *
 * @param {number} count Number of feature items.
 *
 * @return {Object[]} Columns layout configuration.
 */
const getCount = memoize( ( count ) => {
	return times( count, () => [ 'gutenify/team-member', {
		className: 'has-shadow-dark',
	} ] );
} );

const Edit = ( props ) => {
	const { attributes, isSelected, className, clientId } = props;
	const { layout, columnSize } = attributes;
	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );
	const wrapperClasses = classnames(
		className,
		`gutenify-admin-team-block-wrapper gutenify-team-${ layout }`,
		`gutenify-team-col-${ columnSize }`
	);

	return (
		<div className={ wrapperClasses }>

			{ isSelected && <Inspector { ...props } /> }
			<BaseWrapper { ...props } sectionID={ clientId }>
				<InnerBlocks
					allowedBlocks={ ALLOWED_BLOCKS }
					template={ getCount( 2 ) }
					templateInsertUpdatesSelection={ false }
					orientation={ 'horizontal' }
					__experimentalCaptureToolbars={ true }
					renderAppender={ () => (
						<InnerBlocks.ButtonBlockAppender />
					) }
				/>
			</BaseWrapper>

		</div>
	);
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;

		return {
			updateInnerBlocks( template ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child ) {
					if ( 'gutenify/team-member' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, {
							layout: template.name,
							titleAlign: template.titleAlign,
							imageAlign: template.imageAlign,
							ratingAlign: template.ratingAlign,
						} );
						const grandChildren = select( 'core/block-editor' ).getBlocksByClientId( child.clientId )[ 0 ].innerBlocks;
						grandChildren.forEach( function( grandChild ) {
							if ( 'core/image' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { align: template.imageAlign } );
							}
							if ( 'core/heading' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { textAlign: template.titleAlign } );
							}
							if ( 'core/paragraph' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { align: template.titleAlign } );
							}
							if ( 'gutenify/star-rating' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { textAlignment: template.ratingAlign } );
							}
							if ( 'core/social-links' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, {
									align: template.socialIconAlign,
									layout: {
										type: 'flex',
										justifyContent: template.socialIconAlign,
									},
								} );
							}
						} );
					}
				} );
			},
			updateInnerBlocks1( template ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child ) {
					if ( 'core/image' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { align: template.imageAlign } );
					}
					if ( 'core/heading' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { textAlign: template.titleAlign } );
					}
					if ( 'core/paragraph' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { align: template.titleAlign } );
					}
					if ( 'core/social-links' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, {
							align: template.socialIconAlign,
							layout: {
								type: 'flex',
								justifyContent: template.socialIconAlign,
							},
						} );
					}
				} );
			},
		};
	} ),
] )( Edit );
